import { inject, Injectable } from '@angular/core';
import { StateService, TargetState, Transition, TransitionService } from '@uirouter/angular';
import { IdService } from '@tdwb/core';

/**
 * This Router service is responsible for assigning uuid to ui-router states
 * that do 3rd party integration
 */
@Injectable({
  providedIn: 'root'
})
export class RouterIntegrationService {
  private readonly stateService = inject(StateService);

  static initHooks(transitionService: TransitionService): void {
    transitionService.onStart(
      { to: '**' }, (transition: Transition): TargetState | void => {
        const params = transition.params();
        if (params !== undefined && Object.getOwnPropertyDescriptor(params, 'uuid') && params.uuid === undefined) {
          const routerIntegrationService: RouterIntegrationService = transition.injector().get(RouterIntegrationService);
          return routerIntegrationService.handlePageTransition(transition);
        }
      });
  }

  private handlePageTransition(transition: Transition): TargetState | void {
    const to = transition.to();
    const params = transition.params(); // initial params, read-only

    to.params = Object.assign({}, params);
    to.params.uuid = IdService.getUUID();

    return this.stateService.target(to.name, to.params);
  }
}
